import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const DEFAULT_COLOR = "gray";

const formMessage = cva("text-sm leading-6", {
  variants: {
    color: {
      gray: "text-gray-500",
      red: "text-red-600",
    },
  },
  defaultVariants: {
    color: DEFAULT_COLOR,
  },
});

type LabelVariantProps = VariantProps<typeof formMessage>;

export interface Props extends LabelVariantProps {
  text?: string;
  content?: React.ReactNode;
  className?: string;
}

const FormMessage = ({
  text,
  content,
  color = DEFAULT_COLOR,
  className,
}: Props) => {
  return (
    <p className={twMerge(formMessage({ color, className }))}>
      {text}
      {content}
    </p>
  );
};

export default FormMessage;
